import { useEffect, useState } from "react";
import { BookOpen, Loader2, MessageCircleQuestion, Star, TrendingUp } from "lucide-react";
import { school } from "../../lib/api";

const ChildProgress = ({ c }) => (
  <div data-testid={`progress-child-${c.username}`} className="rounded-xl border border-white/[0.07] p-4">
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <p className="font-display font-semibold text-white">{c.name}</p>
      <p className="text-xs font-mono text-slate-500">
        <span data-testid="progress-question-count">{c.question_count} questions</span> · <span data-testid="progress-word-count">{c.words.length} words</span>
        {c.quiz.played > 0 && <span data-testid="progress-quiz"> · quiz {c.quiz.correct}/{c.quiz.total}</span>}
      </p>
    </div>
    <div className="grid sm:grid-cols-2 gap-4 mt-3">
      <div>
        <p className="text-[11px] uppercase tracking-[0.16em] text-slate-500 font-mono flex items-center gap-1.5"><MessageCircleQuestion size={12} /> Topics explored</p>
        {c.topics.length ? (
          <ul data-testid="progress-topics" className="mt-2 space-y-1 text-sm text-slate-300">{c.topics.slice(0, 8).map((t, i) => <li key={i} className="truncate">• {t}</li>)}</ul>
        ) : <p className="text-sm text-slate-500 mt-2">No questions this week.</p>}
      </div>
      <div>
        <p className="text-[11px] uppercase tracking-[0.16em] text-slate-500 font-mono flex items-center gap-1.5"><BookOpen size={12} /> Words discovered</p>
        {c.words.length ? (
          <div data-testid="progress-words" className="mt-2 flex flex-wrap gap-1.5">
            {c.words.map((w) => <span key={w.word} title={w.meaning} className="px-2 py-0.5 rounded-full text-xs bg-[#FBBF24]/10 text-[#FBBF24] border border-[#FBBF24]/30">{w.word}</span>)}
          </div>
        ) : <p className="text-sm text-slate-500 mt-2">No saved words this week.</p>}
      </div>
    </div>
  </div>
);

export const ProgressCard = ({ classId }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { school.progress(classId).then(setData).catch(() => setError(true)); }, [classId]);

  return (
    <div data-testid="family-progress-card" className="what-plan">
      <p className="font-display font-semibold text-white flex items-center gap-2"><TrendingUp size={16} /> This week's progress</p>
      <p className="text-xs text-slate-500 mt-1 flex items-center gap-1.5"><Star size={11} /> What each child asked about and the words they saved in the last 7 days.</p>
      <div className="mt-4 space-y-3">
        {error ? <p className="text-sm text-red-400">Couldn't load progress.</p>
          : !data ? <Loader2 className="animate-spin text-slate-500" />
          : data.children.length === 0 ? <p data-testid="progress-empty" className="text-sm text-slate-500">Add children to see their progress here.</p>
          : data.children.map((c) => <ChildProgress key={c.user_id} c={c} />)}
      </div>
    </div>
  );
};
